<label class="p1"
       [class]="{'flex flex-middle' : middle}">
    <ng-content />
</label>